import React from 'react';
import { FormattedMessage } from 'react-intl';

const EmptyRuleset = () => (
  <div>
    <FormattedMessage id="autograder.rulesetNotFound" />
  </div>
);

export default EmptyRuleset;
